module.exports = __webpack_public_path__ + "media/images/ui__arrowRightInactive-ec5873c0b0dcb8ab7fa2110d61d0acbb.png";